var _g, _path, _path2, _ellipse, _polygon, _ellipse2, _polygon2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutOfMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "tiny",
    id: "Layer_3",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1049",
    xmlSpace: "preserve",
    className: "injected-svg",
    "data-src": "https://d9i3cp4r5rckd.cloudfront.net/5e77892382ee7943cf440494_2.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D9E4F9",
    d: "M818.7,1040.5c0,5.6-85.6,10.1-191.3,10.1c-105.6,0-191.3-4.5-191.3-10.1c0-5.6,85.6-10.1,191.3-10.1     C733.1,1030.4,818.7,1034.9,818.7,1040.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAF4",
    d: "M1142.6,87.7h-4.6c0-0.6,0.1-1.1,0.1-1.7c0-14.1-11.6-25.7-25.7-25.7h-20.1c0-0.4,0-0.8,0-1.1     c0-14.8-12.1-26.8-26.8-26.8h-5.2c-14.8,0-26.8,12.1-26.8,26.8c0,0.4,0,0.8,0,1.1h-25.2c-14.1,0-25.7,11.6-25.7,25.7     c0,0.6,0,1.1,0.1,1.7h-12.9c-13.2,0-24,10.8-24,24c0,13.2,10.8,24,24,24h172.9c13.2,0,24-10.8,24-24     C1166.6,98.5,1155.8,87.7,1142.6,87.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAF4",
    d: "M293.7,162.8h2.3c0-0.3,0-0.6,0-0.8c0-7.1,5.8-12.8,12.8-12.8h10.1c0-0.2,0-0.4,0-0.6     c0-7.4,6-13.4,13.4-13.4h2.6c7.4,0,13.4,6,13.4,13.4c0,0.2,0,0.4,0,0.6h12.6c7.1,0,12.8,5.8,12.8,12.8c0,0.3,0,0.6,0,0.8h6.5     c6.6,0,12,5.4,12,12s-5.4,12-12,12h-86.4c-6.6,0-12-5.4-12-12S287.1,162.8,293.7,162.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_-75",
    gradientUnits: "userSpaceOnUse",
    x1: 1070.7803,
    y1: 414.0714,
    x2: 1070.7803,
    y2: 820.945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1B2F3"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_1_-75)",
    cx: 1070.8,
    cy: 617.5,
    rx: 127.6,
    ry: 203.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#56548C",
    points: "1136.9,707.5 1077.1,760 1074.9,626.8 1066.6,626.8 1065.2,715.6 1009,666.7 1064.9,731.1       1060.8,983.2 1080.8,983.2 1077.4,775.3     "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_-76",
    gradientUnits: "userSpaceOnUse",
    x1: 200.3426,
    y1: 596.1084,
    x2: 200.3426,
    y2: 854.9776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1B2F3"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_2_-76)",
    cx: 200.3,
    cy: 725.5,
    rx: 81.2,
    ry: 129.4
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#56548C",
    points: "242.4,782.8 204.4,816.2 203,731.5 197.7,731.5 196.8,787.9 161,756.9 196.6,797.8 194,958.2       206.7,958.2 204.5,826     "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#56548C",
    points: "164.5,670.5 86.9,738.6 84.1,565.7 73.3,565.7 71.4,681 -1.6,617.5 71,701 65.7,1028.4       91.6,1028.4 87.2,758.5     "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_-77",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7607,
    y1: 842.8282,
    x2: 312.7607,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_-77)",
    d: "M360.3,843c9.5,3.3-1.3,66-32.6,188.1c-10.7,0-22,0-33.8,0c17.1-47.1,33.2-94.6,48.5-142.3        c0.8-2.6-0.7-3.1-1.7-0.6c-18.1,47.2-35.2,94.9-51.2,142.9c-9,0-18.2,0-27.6,0C317.4,902.2,350.2,839.5,360.3,843z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_-78",
    gradientUnits: "userSpaceOnUse",
    x1: 316.0909,
    y1: 886.4779,
    x2: 316.0909,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_-78)",
    d: "M340.8,888.1c0.9-2.5,2.5-2,1.7,0.6c-15.3,47.7-31.4,95.2-48.5,142.3c-1.5,0-2.9,0-4.4,0        C305.6,983,322.7,935.4,340.8,888.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_-79",
    gradientUnits: "userSpaceOnUse",
    x1: 200.7599,
    y1: 643.6343,
    x2: 200.7599,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_-79)",
    d: "M240.4,1031c-12.1,0-24.1,0-36,0l0.3-13.4l0.6-23.5c1-31.4,1.9-62.8,2.9-94.2        c2-62.8,3.9-125.6,5.9-188.4c0.2-5-1.5-4.9-1.8-0.1c-3.8,62.7-6.8,125.5-8.9,188.3c-1,31.4-1.8,62.8-2.2,94.2l-0.2,23.6        l0,13.5c-13.6,0-27,0-40,0c25.8-287.2,43.1-387.8,54.8-387.4C227.5,644.1,236.9,745.1,240.4,1031z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_-80",
    gradientUnits: "userSpaceOnUse",
    x1: 207.6396,
    y1: 707.8118,
    x2: 207.6396,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_-80)",
    d: "M212.4,711.5c0.3-4.8,1.9-4.9,1.8,0.1c-2,62.8-3.9,125.6-5.9,188.4c-1,31.4-1.9,62.8-2.9,94.2        l-0.6,23.5l-0.3,13.4c-1.1,0-2.3,0-3.4,0l0-13.5l0.2-23.6c0.4-31.4,1.2-62.8,2.2-94.2C205.6,836.9,208.6,774.1,212.4,711.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_-81",
    gradientUnits: "userSpaceOnUse",
    x1: 148.5694,
    y1: 765.0582,
    x2: 148.5694,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_-81)",
    d: "M174.1,1031c-7,0-14,0-20.7,0c-0.8-68.8-3.7-137.6-7.8-206.4c-0.2-2.9-1.8-2.8-1.8,0.1        c0.6,68.8,2.9,137.6,7,206.3c-9.5,0-18.8,0-27.7,0c2.6-159.4,11.4-265.7,18.9-266C149.9,764.8,160.6,853.5,174.1,1031z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_-82",
    gradientUnits: "userSpaceOnUse",
    x1: 148.5314,
    y1: 822.5483,
    x2: 148.5314,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_-82)",
    d: "M153.3,1031c-0.9,0-1.7,0-2.6,0c-4.1-68.7-6.4-137.5-7-206.3c0-2.8,1.6-3,1.8-0.1        C149.6,893.4,152.5,962.2,153.3,1031z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_-83",
    gradientUnits: "userSpaceOnUse",
    x1: 102.4411,
    y1: 853.6808,
    x2: 102.4411,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_-83)",
    d: "M135.7,1031c-6.9,0-13.6,0-20,0c-9.4-45.9-20.4-91.4-32.5-136.7c-0.6-2.1-2.1-1.7-1.7,0.4        c8.9,45.7,19,91.2,30.7,136.3c-10.2,0-19.6,0-28.1,0C68.8,914.5,65.2,855.4,73.4,853.7C81.8,852,102.5,911.1,135.7,1031z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_-84",
    gradientUnits: "userSpaceOnUse",
    x1: 98.5736,
    y1: 892.8832,
    x2: 98.5736,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_-84)",
    d: "M115.7,1031c-1.2,0-2.3,0-3.5,0c-11.6-45.1-21.8-90.6-30.7-136.3c-0.4-2.1,1.2-2.5,1.7-0.4        C95.3,939.6,106.3,985.1,115.7,1031z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_-85",
    gradientUnits: "userSpaceOnUse",
    x1: 275.5563,
    y1: 742.4344,
    x2: 275.5563,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_-85)",
    d: "M335.1,742.5c8.6,2.7-12.5,98.9-63.3,288.5c-10.1,0-20.3,0-30.6,0        c26.5-76.5,51.7-153.6,76-230.9c1.2-3.9-0.4-4.3-1.7-0.6c-27.3,76.7-53.4,153.9-78.2,231.4c-7.6,0-15.3,0-23,0        C285.9,835.9,326.2,739.7,335.1,742.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_-86",
    gradientUnits: "userSpaceOnUse",
    x1: 277.3656,
    y1: 797.0291,
    x2: 277.3656,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_-86)",
    d: "M315.4,799.6c1.3-3.7,2.9-3.3,1.7,0.6c-24.3,77.3-49.5,154.3-76,230.9c-1.3,0-2.6,0-4,0        C262,953.5,288.2,876.3,315.4,799.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_-87",
    gradientUnits: "userSpaceOnUse",
    x1: 1133.5127,
    y1: 838.356,
    x2: 1133.5127,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_-87)",
    d: "M1182.2,838.5c9.8,3.4-1.3,67.5-33.3,192.5c-10.9,0-22.5,0-34.6,0        c17.5-48.2,34-96.8,49.6-145.7c0.8-2.7-0.7-3.1-1.7-0.6c-18.5,48.4-36,97.2-52.4,146.3c-9.2,0-18.6,0-28.3,0        C1138.3,899.1,1171.8,834.9,1182.2,838.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_-88",
    gradientUnits: "userSpaceOnUse",
    x1: 1136.922,
    y1: 883.0428,
    x2: 1136.922,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_-88)",
    d: "M1162.2,884.7c1-2.5,2.6-2.1,1.7,0.6c-15.7,48.9-32.1,97.5-49.6,145.7c-1.5,0-3,0-4.5,0        C1126.1,981.9,1143.7,933.1,1162.2,884.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_-89",
    gradientUnits: "userSpaceOnUse",
    x1: 1018.8502,
    y1: 634.4282,
    x2: 1018.8502,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_-89)",
    d: "M1059.5,1031c-12.3,0-24.7,0-36.8,0l0.3-13.7l0.6-24.1c1-32.1,2-64.3,3-96.4        c2-64.3,4-128.6,6-192.9c0.2-5.1-1.5-5-1.8-0.1c-3.9,64.2-6.9,128.5-9.1,192.8c-1.1,32.2-1.8,64.3-2.3,96.5l-0.2,24.1l0,13.8        c-13.9,0-27.6,0-40.9,0c26.4-294,44.1-397.1,56.1-396.6C1046.2,634.9,1055.8,738.3,1059.5,1031z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_-90",
    gradientUnits: "userSpaceOnUse",
    x1: 1025.8934,
    y1: 700.1309,
    x2: 1025.8934,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_-90)",
    d: "M1030.8,703.9c0.3-5,2-5,1.8,0.1c-2,64.3-4,128.6-6,192.9c-1,32.1-2,64.3-3,96.4l-0.6,24.1        l-0.3,13.7c-1.2,0-2.3,0-3.5,0l0-13.8l0.2-24.1c0.4-32.2,1.2-64.3,2.3-96.5C1023.8,832.3,1026.9,768,1030.8,703.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_-91",
    gradientUnits: "userSpaceOnUse",
    x1: 965.4194,
    y1: 758.7377,
    x2: 965.4194,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_-91)",
    d: "M991.5,1031c-7.2,0-14.3,0-21.2,0c-0.9-70.4-3.8-140.9-8-211.3c-0.2-3-1.8-2.8-1.8,0.1        c0.6,70.4,3,140.9,7.2,211.2c-9.8,0-19.2,0-28.3,0c2.6-163.2,11.7-272,19.3-272.3C966.8,758.5,977.7,849.3,991.5,1031z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_-92",
    gradientUnits: "userSpaceOnUse",
    x1: 965.3807,
    y1: 817.5939,
    x2: 965.3807,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_-92)",
    d: "M970.3,1031c-0.9,0-1.7,0-2.6,0c-4.2-70.3-6.6-140.8-7.2-211.2c0-2.9,1.6-3.1,1.8-0.1        C966.5,890.1,969.4,960.6,970.3,1031z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_-93",
    gradientUnits: "userSpaceOnUse",
    x1: 918.1948,
    y1: 849.4666,
    x2: 918.1948,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_-93)",
    d: "M952.3,1031c-7.1,0-13.9,0-20.5,0c-9.7-47-20.9-93.6-33.2-140c-0.6-2.2-2.2-1.7-1.8,0.4        c9.1,46.8,19.5,93.4,31.4,139.6c-10.4,0-20,0-28.7,0c-15.7-119.3-19.3-179.8-11-181.5C897,847.8,918.3,908.3,952.3,1031z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_-94",
    gradientUnits: "userSpaceOnUse",
    x1: 914.2354,
    y1: 889.6003,
    x2: 914.2354,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_-94)",
    d: "M931.8,1031c-1.2,0-2.4,0-3.6,0c-11.9-46.2-22.3-92.8-31.4-139.6c-0.4-2.1,1.2-2.6,1.8-0.4        C910.8,937.4,922.1,984.1,931.8,1031z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_-95",
    gradientUnits: "userSpaceOnUse",
    x1: 1095.4241,
    y1: 735.5762,
    x2: 1095.4241,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#77CEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    style: {
      stopColor: "#7FADF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    style: {
      stopColor: "#878CF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7724,
    style: {
      stopColor: "#7E7FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#685EFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B4BFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_-95)",
    d: "M1156.3,735.6c8.8,2.8-12.8,101.2-64.8,295.4c-10.3,0-20.8,0-31.3,0        c27.1-78.3,52.9-157.2,77.8-236.4c1.2-3.9-0.4-4.4-1.7-0.6c-27.9,78.5-54.7,157.5-80.1,236.9c-7.8,0-15.7,0-23.5,0        C1106,831.2,1147.3,732.8,1156.3,735.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_-96",
    gradientUnits: "userSpaceOnUse",
    x1: 1097.2765,
    y1: 791.4682,
    x2: 1097.2765,
    y2: 1031.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5277FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30009F"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_-96)",
    d: "M1136.2,794.1c1.3-3.8,3-3.4,1.7,0.6c-24.9,79.1-50.7,158-77.8,236.4c-1.3,0-2.7,0-4.1,0        C1081.6,951.6,1108.3,872.6,1136.2,794.1z"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4E7EAC",
    d: "M609,491.5c-33.3-8.2-51.2-7-51.2-7l-2.2,23.7c-8.3,5.3-11.2,14.6-11.2,14.6l-3.3,27.5l28.4,206.5       l8.4,15.2c13.9,129.5,16.2,252.6,16.2,252.6l14.7,1.4l5.5-85.9c7.8-13.6,6.4-49.1,6.4-49.1l-8.3-43l-0.5-29.3       c0.9-85.9-6.4-196.9-6.4-196.9l8.7-6.8h12.4l0.7-123.4H609z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4E7EAC",
    d: "M635.2,491.7c33.3-8.2,44.5-7,44.5-7l8.9,23.7c8.3,5.3,11.2,14.6,11.2,14.6l3.3,27.5L674.7,757       l-8.4,15.3c-13.9,129.5-16.2,252.6-16.2,252.6l-14.7,1.4l-5.5-85.9c-7.8-13.6-6.4-49.1-6.4-49.1l8.3-43l0.5-29.3       c-0.9-85.9,6.4-196.9,6.4-196.9l-8.7-6.8h-12.4l-0.7-123.4H635.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3ED9C7",
    d: "M706.9,244.3c0-0.1,0-0.3,0-0.4c-0.1-2,0-4,0.3-6c0-0.2,0-0.4,0-0.6c-0.6-3.7-0.9-7.5-1.1-11.2       c-0.3-5.8,0.4-11.9,1.9-18c-0.3-0.2-0.7-0.5-1-0.7v-0.1l-0.2-0.1c0,0-0.1,0-0.1-0.1v0l-74-29.7l-83.5,19.3v69.6L574,406.6       l-5.5,29.5l-6.1,3.5l-6.8,66.9c83.3,16,113.7,9.3,132.9,0.2l-0.1-203l18.4-44V244.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#001C45",
    points: "433,498.6 565.5,631 557.8,528.7      "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#001C45",
    points: "820.9,509.5 687,625.7 676.1,535.2      "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3ED9C7",
    d: "M551.1,196.5c-25.9,11.6-61.8,37.7-98.9,103.8c0,0-36.6,70.2-39.1,180.8l12.5-1.4        c3.6-44.7,12.4-103.9,47.6-171.6c0,0,35-57.6,70-75.4l6.2-6.4L551.1,196.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A8D",
    d: "M413.2,481.1l4.4,20.9l3.2,1.7l4.1-1.1l4.4,2.1l3.5-2.6l14.4,11.9l2.1-2.4l-11.7-12.2l13.3,7.5l1.5-3.1       l-14.8-9.4c0,0-8.5-10.9,2.7-14.5c0,0,2.1-1.7,1.7-4.1l-15.6,4.3l-0.9-0.3L413.2,481.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3ED9C7",
    d: "M705,206.7c25.9,11.6,61.8,37.7,98.9,103.8c0,0,36.6,70.2,39.1,180.8l-12.5-1.4        c-3.6-44.7-12.4-103.9-47.6-171.6c0,0-35-57.6-70-75.4l-6.2-6.4L705,206.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A8D",
    d: "M842.9,491.3l-4.4,20.9l-3.2,1.7l-4.1-1.1l-4.4,2.1l-3.5-2.6l-14.4,11.9l-2.1-2.4l11.7-12.2l-13.3,7.5       l-1.5-3.1l14.8-9.4c0,0,8.5-10.9-2.7-14.5c0,0-2.1-1.7-1.7-4.1l15.6,4.3l0.9-0.3L842.9,491.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_812_-97",
    fill: "#FF9A8D",
    d: "M612.9,157.7c0,0-0.3,12.2-1.4,17.3c-1.1,5.1,0,7.7-15.4,10.4c0,0,6.3,20.2,33,23.7     c26.8,3.5,37.7-17.6,36.9-17.6c-0.8,0-8.3-3.1-10.7-4.6c-2.4-1.6-0.6-31.1-0.6-31.1L612.9,157.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1569_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1577_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1637_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1644_-98",
    fill: "#FF9A8D",
    d: "M580.7,93c0,0-9.7-2.7-14.9,4.1c-5.2,6.8-1.3,21,8.8,24.4c9.6,3.3,13.5-1.9,13.5-1.9        L580.7,93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1641_-99",
    fill: "#BA5964",
    d: "M571.2,99.3c2.4-0.9,6-0.9,8.1,0.7c0.8,0.6-0.5,1.9-1.2,1.6        c-4.1-1.4-9.1-1.5-11.1,3.3c-0.1,0.3-0.3,0-0.3-0.2C567.2,102.1,568.7,100.3,571.2,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1638_-100",
    fill: "#BA5964",
    d: "M573.1,99.6c0.4-0.2,1.5,0.9,1.4,1.2c-0.7,0.3-1.7,1.1-2.2,2        c-0.8,1.6-1.1,2.9-0.9,4.7c0.4,4.1,2.8,7,6.8,7.8c0.1,0,0.2,0.2,0.1,0.3c-3.5,0.9-7.5-2.6-8.3-5.7        C569.1,106.5,569.2,101.6,573.1,99.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1627_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1634_-101",
    fill: "#FF9A8D",
    d: "M678.2,85.4c0,0,9.2-4.1,15.3,1.8c6.1,5.9,4.5,20.5-4.9,25.4        c-9,4.7-13.6,0.2-13.6,0.2L678.2,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1631_-102",
    fill: "#BA5964",
    d: "M688.6,90.2c-2.5-0.5-6.1,0.1-7.9,2c-0.7,0.7,0.8,1.8,1.5,1.4        c3.9-2.1,8.8-2.9,11.4,1.5c0.1,0.2,0.3,0,0.2-0.2C692.9,92.4,691.2,90.8,688.6,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1628_-103",
    fill: "#BA5964",
    d: "M686.7,90.8c-0.5-0.2-1.4,1.1-1.2,1.4c0.7,0.2,1.9,0.8,2.5,1.7        c1.1,1.4,1.5,2.7,1.6,4.5c0.2,4.1-1.7,7.3-5.5,8.8c-0.1,0-0.2,0.2,0,0.3c3.6,0.4,7-3.7,7.3-6.9        C691.8,97,690.9,92.2,686.7,90.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1611_-104",
    fill: "#FF9A8D",
    d: "M648.3,33.6c-7.4-3.5-15.4-5.3-23.5-4.6c-8,0.6-16.2,3.2-22.9,7.8       c-15.7,10.7-23.5,29.6-22,48.3c0,0,0,0.1,0,0.1c0.4,5.3,1.1,10.7,2.2,15.9l1.4,7.3c1.1,5.8,3.9,16.8,9.1,27.2       c10.4,20.7,30.4,26.1,42.4,25.2c12-0.9,31-9.4,38-31.5c3.6-11.1,4.6-22.5,4.8-28.3l0.3-7.5c0.2-5.4,0.1-10.7-0.3-16.1       c0,0,0-0.1,0-0.1C676.4,58.8,665.5,41.8,648.3,33.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1570_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1572_-105",
    fill: "none",
    stroke: "#001C45",
    strokeWidth: 2.198,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "       M559.5,37.6c0,0,18.7-1.5,24.6,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1571_-106",
    fill: "none",
    stroke: "#001C45",
    strokeWidth: 2.198,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "       M561,19.5c0,0,22.2,6.4,23.2,28.4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_144_-107",
    fill: "#001C45",
    d: "M591.7,47.1c0,0,10.6,20.7,31,28.7c20.4,8.1,35-14.9,34.1-26.2c0,0,16.8,35.4,21.4,35.8      c0,0,6.5-12.8,6.6-27.9c0-15.1-6.2-23.3-13.2-29.7c-6.7-6.1-14.1-3.7-17.2-2.1c-3-7.6-12.6-24.1-35-24.2      c-25.1,0-36.7,16-36,42.6c0,0-9-3.7-15.8,6.5c-6.8,10.2-3,31.9,3.3,42.7c0,0,6.7-1.3,9.7-0.4c0,0-2.4-17.8,3.4-32.5      C588.8,48.6,591.7,47.1,591.7,47.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#363A68",
    d: "M612.7,968.4c-0.1,0-0.1,0-0.2-0.1c-1.6,0.6-3.3,1.2-4.9,1.7C609.8,969.4,611.5,968.8,612.7,968.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A68",
    d: "M693.3,1025.9c-26.6,0-34.3-22.9-36.3-31.6c-7.4,1.1-14.9,1.9-22.2,2.5c-1,9.3-5.4,39.8-5.4,39.8     s24,0,39.9,0c16,0,55.9,0,55.9,0S726.1,1025.9,693.3,1025.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A68",
    d: "M609.2,996.9c-6.3-1-12.4-2.8-18.2-5.5l0.5,3.6c0,0-3.4,34.8-30.6,34.8c-27.2,0-26.5,10.7-26.5,10.7     s33.1,0,46.4,0c13.3,0,33.1,0,33.1,0s-4.6-38.6-4.6-42.2C609.2,998.2,609.2,997.7,609.2,996.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3A75A5",
    strokeWidth: 1.2817,
    strokeMiterlimit: 10,
    x1: 565.5,
    y1: 631,
    x2: 557.8,
    y2: 528.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3A75A5",
    strokeWidth: 1.2817,
    strokeMiterlimit: 10,
    x1: 687,
    y1: 625.7,
    x2: 676.1,
    y2: 535.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1507_-108",
    fill: "#3B55CE",
    d: "M888.4,523.7L851.9,559l-13.3-11.8l32.2-39L888.4,523.7z M842.7,570.5    c-0.9,1.1-2,1.9-3.2,2.4c-1.2,0.6-2.5,0.9-3.8,0.9c-1.3,0.1-2.6-0.1-3.8-0.5c-1.3-0.4-2.4-1.1-3.4-2c-1.1-0.9-1.9-2-2.4-3.2    c-0.6-1.2-0.9-2.4-1-3.7c-0.1-1.3,0.1-2.6,0.5-3.8c0.4-1.3,1.1-2.4,2-3.5c0.9-1,2-1.8,3.2-2.4c1.2-0.6,2.5-0.9,3.8-1    c1.3-0.1,2.6,0.1,3.8,0.5c1.3,0.4,2.4,1.1,3.5,2c1,0.9,1.8,2,2.4,3.2c0.5,1.2,0.9,2.5,0.9,3.8c0.1,1.3-0.1,2.6-0.5,3.9    C844.3,568.3,843.6,569.5,842.7,570.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1513_-109",
    fill: "#3B55CE",
    d: "M875.9,596.8L872,581c3.2-1,6-1.5,8.4-1.5c2.4,0,4.4,0.4,6.1,1c1.7,0.6,3.2,1.5,4.4,2.5    c1.2,1,2.3,2.1,3.3,3.1c1,1,1.9,1.9,2.7,2.7c0.9,0.8,1.8,1.2,2.8,1.3c0.6,0.1,1.3,0,2-0.3c0.7-0.3,1.3-0.8,1.8-1.5    c0.5-0.7,0.9-1.7,1-2.8c0.2-1.2,0.1-2.6-0.4-4.3c-0.3-1.1-0.7-2.4-1.3-3.9c-0.6-1.5-1.3-3-2.1-4.6c-0.8-1.6-1.8-3.1-2.8-4.6    c-1-1.5-2.1-2.8-3.2-3.9l17.8-6.6c1,1,2,2.1,3.1,3.4c1.1,1.3,2.1,2.7,3.2,4.3c1,1.6,2,3.4,2.8,5.3c0.9,2,1.6,4.1,2.2,6.5    c1,3.8,1.3,7.6,1.1,11.2c-0.2,3.7-1,7-2.4,10.1c-1.4,3.1-3.4,5.7-6.1,8c-2.6,2.2-5.9,3.8-9.8,4.8c-3,0.7-5.4,0.9-7.4,0.5    c-2-0.4-3.7-1.1-5.2-2.1c-1.5-1-2.8-2.2-4-3.7s-2.4-2.8-3.7-4.1c-1.3-1.3-2.8-2.4-4.4-3.4C880.4,597.4,878.4,596.9,875.9,596.8z     M864.2,602.2c-1.4,0.3-2.7,0.4-4,0.2c-1.3-0.2-2.5-0.7-3.6-1.3c-1.1-0.7-2.1-1.5-2.9-2.6c-0.8-1.1-1.4-2.2-1.7-3.6    c-0.3-1.4-0.4-2.7-0.2-4c0.2-1.3,0.7-2.5,1.3-3.6c0.7-1.1,1.5-2.1,2.6-2.9c1.1-0.8,2.3-1.4,3.6-1.7c1.3-0.3,2.7-0.4,4-0.2    c1.3,0.2,2.6,0.6,3.7,1.3c1.1,0.7,2.1,1.5,2.9,2.6c0.8,1,1.4,2.3,1.7,3.6c0.3,1.3,0.4,2.7,0.2,4c-0.2,1.3-0.7,2.5-1.3,3.6    c-0.7,1.1-1.5,2.1-2.6,2.9C866.8,601.3,865.6,601.8,864.2,602.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_-110",
    fill: "#3B55CE",
    d: "M394.9,509.9l35.2,36.5l-11.8,13.3l-39-32.2L394.9,509.9z M441.7,555.7    c1.1,0.9,1.9,2,2.4,3.2c0.6,1.2,0.9,2.5,0.9,3.8c0.1,1.3-0.1,2.6-0.5,3.8c-0.4,1.3-1.1,2.4-2,3.4c-0.9,1.1-2,1.9-3.2,2.4    c-1.2,0.6-2.4,0.9-3.7,1c-1.3,0.1-2.6-0.1-3.8-0.5c-1.3-0.4-2.4-1.1-3.5-2c-1-0.9-1.8-2-2.4-3.2c-0.6-1.2-0.9-2.5-1-3.8    c-0.1-1.3,0.1-2.6,0.5-3.8c0.4-1.3,1.1-2.4,2-3.5c0.9-1,2-1.8,3.2-2.4c1.2-0.5,2.5-0.9,3.8-0.9c1.3-0.1,2.6,0.1,3.9,0.5    C439.5,554.1,440.6,554.8,441.7,555.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_-111",
    fill: "#3B55CE",
    d: "M378.5,594.1c-1.9,0.4-3.7,0.9-5.3,1.8c-1.7,0.8-3.3,1.7-4.9,2.7c-1.6,1-3.2,1.7-5,2.2    c-1.7,0.5-3.6,0.6-5.6,0.3c-2-0.3-4.3-1.3-6.8-2.9c-3.4-2.2-5.9-4.8-7.6-7.8c-1.7-3-2.8-6.1-3.1-9.5c-0.3-3.4,0-6.8,1-10.3    c1-3.5,2.6-6.9,4.7-10.2c1.3-2,2.7-3.8,4.2-5.4c1.5-1.6,3-2.9,4.4-4.1c1.5-1.2,2.9-2.2,4.4-3c1.4-0.8,2.8-1.6,4-2.2l14.6,12.1    c-1.4,0.7-2.8,1.6-4.3,2.6c-1.4,1.1-2.8,2.2-4.1,3.4c-1.3,1.2-2.5,2.4-3.5,3.6c-1,1.2-1.9,2.3-2.5,3.3c-1,1.5-1.6,2.8-1.8,4    c-0.2,1.2-0.2,2.2,0.1,3c0.3,0.8,0.7,1.5,1.3,2c0.6,0.5,1.2,0.8,1.8,0.9c1,0.2,2,0.1,3.1-0.3c1.1-0.4,2.2-1,3.5-1.6    c1.3-0.7,2.6-1.3,4.1-1.8c1.5-0.6,3.2-0.9,5-0.9c1.8,0,3.9,0.3,6.1,1.1c2.3,0.7,4.7,2.1,7.5,4.2l-8.9,13.6    C382.5,593.9,380.4,593.8,378.5,594.1z M391.3,600.7c-0.7-1.1-1.3-2.3-1.5-3.6c-0.3-1.3-0.3-2.6-0.1-3.9c0.2-1.3,0.7-2.6,1.4-3.7    c0.8-1.2,1.7-2.1,2.8-2.9c1.1-0.7,2.3-1.2,3.6-1.5c1.3-0.3,2.6-0.3,3.9,0c1.3,0.2,2.6,0.7,3.7,1.5c1.2,0.8,2.1,1.7,2.9,2.8    c0.7,1.1,1.2,2.3,1.5,3.6c0.3,1.3,0.3,2.6,0.1,3.9c-0.2,1.3-0.7,2.6-1.5,3.7c-0.8,1.2-1.7,2.1-2.8,2.8c-1.1,0.7-2.3,1.2-3.6,1.5    c-1.3,0.3-2.6,0.3-3.9,0.1c-1.3-0.2-2.6-0.7-3.7-1.5C393,602.8,392,601.9,391.3,600.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfMoney);
export default __webpack_public_path__ + "static/media/Out-of-money.32aac6e88d499d2eedf42c101cbecc34.svg";
export { ForwardRef as ReactComponent };